import axios from "axios";
export const getPromotionConfig = data => {
  return axios.request({
    url: `/api/promotion/update`,
    method: "post",
    data
  });
};